import { render } from "./LoginAuswahl.vue?vue&type=template&id=04213b82&scoped=true"
import script from "./LoginAuswahl.vue?vue&type=script&lang=js"
export * from "./LoginAuswahl.vue?vue&type=script&lang=js"

import "./LoginAuswahl.vue?vue&type=style&index=0&id=04213b82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04213b82"]])

export default __exports__